let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a9HJF")).then(() => parcelRequire('1hmpK'));